import React, { Component } from "react";
import { Formik, Form, Field } from 'formik';
import 'bootstrap/dist/css/bootstrap.min.css'; 
import "./App.css";
import "./form/FormInput.css";
import QRdiv from './qrcode/QRdiv'
import ChangeStyleQR from './qrcode/ChangeStyleQR'
import SketchColor from "./form/SketchColor.js";
import SEO from './seo/SEO'
import {Navbar, Nav} from 'react-bootstrap';
import ImageUploader from 'react-images-upload';

/*eslint-disable no-eval */

class App extends Component {
  constructor({ match, location }) {
    super();
//	const {
//		params: { formName }
//	} = match;
	


/*	const formIDs = [
	  {
		name: 'yamoney',
		id: 10
	  },
	  {
		name: 'sbp',
		id: 20
	  },
	  {
		name: 'wifi',
		id: 30
	  },
	  {
		name: 'phone',
		id: 40
	  },
	  {
		name: 'text',
		id: 50
	  },
	  {
		name: 'url',
		id: 60
	  }
	  
	];
	
*/
	
	let formId = 0;
//	formIDs.forEach( (item,key) => {if (item.name === formName) { formId = item.id }  });
	formId=60;
	//console.log('formId = ' + formId);
	
    this.state = {
	  formData: [],
	  idQR: "qr_code_1",
	  valueQR: "https://sbqr.ru",
	  isVisiableQR: false,
	  sizeQR: 100,
	  opacityQR: 100,
	  levelQR: "H",
	  typeQR: "rect",
	  posTypeQR: "rect",
	  posTypeQR2: "dsj",
	  otherColorQR: "#000",
	  posColorQR: "#000",
	  circleColorQR: "#000",
	  scaleQR: 70,
	  crossWidthQR: 70,
	  posWidhQR: 90,
	  lineWidthQR: 50,
	  directionQR: "left-right",
	  funcTypeQR: "A",
	  isMarginQR: true,
      formId: formId,
	  isFill: false,
      title: "Создать QR код с логотипом и дизайном",
//	  formName: formName,
	  QRstyle: "QRNormal",
	  icon: null,
	  imgQR: null
    };
  }
  
     
  
  componentDidMount() {
    const formId = this.state.formId;	
	
    const URL = "https://sbqr.ru/qr/get_form.php?id=" + formId;
    fetch(URL)
	.then(res => res.json())
	.then(json => {
      this.setState({ formData: json });
    });
	
	const URL2 = "https://sbqr.ru/qr/get_text_form.php?id=" + formId;
	let title = "";
	let intro = "";
	let body = "";
	let finality = "";
    fetch(URL2)
	.then(res2 => res2.json())
	.then(result => {
	    title = Object.values(result)[0].TITLE;
		intro = Object.values(result)[0].INTRO;
		body = Object.values(result)[0].BODY;
		finality = Object.values(result)[0].FINALITY;
      this.setState({ title: title,
					  intro: intro,
	                  body: body,                      
					  finality: finality
					  });
    });		
	//document.title = this.state.title;
			
	
	
  }
  
handleChangeQR(event){
	 const {name, value} = event.target
	 this.setState({ [name]: value});      
	
}

updateChangeQR = (value) => {
	 this.setState({ QRstyle: value});      	
}


updateDataPosColor = (color) => {   
  this.setState({ posColorQR: color });  
}

updateDataСircleColor = (color) => {   
  this.setState({ circleColorQR: color });  
}

updateDataOtherColor = (color) => {   
  this.setState({ otherColorQR: color });  
}

 onDrop(picture) {
	    console.log('Загрузка изображения ' + picture[0].name );
		
		let file = picture[0];
		//console.log('Путь изображения ' + URL.createObjectURL(picture[0]) );
		let reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onloadend = () => {
		  this.setState({			
			icon: reader.result,
			imgQR: URL.createObjectURL(file)			
			});        
			}
		
 }
 
  render() {
    const formData = this.state.formData;
	const title = this.state.title;
    const intro = this.state.intro;	
	const body = this.state.body;
	const finality = this.state.finality;
	const formName = this.state.formName;
	
	const visualParametrs = {  
    'QRNormal': ['sizeQR','typeQR','posTypeQR','opacityQR','imgQR','otherColorQR','posColorQR'],
    'QRResImage': ['imgQR','otherColorQR','posColorQR'],	
	'QRBubble': ['posColorQR','circleColorQR'],
	'QRDsj': ['posTypeQR2','scaleQR','crossWidthQR','posWidhQR'],
	'QRLine': ['lock_funcTypeQR','directionQR','opacityQR','otherColorQR','posColorQR','lineWidthQR'],
	'QRRandRect': []
	}
  

	
    return (	 
	 
	 
	 <div className="wrapper"> 
	 
{/*	  	   <SEO 
		 title = {title}
		 description = {intro}
		 thumbnail = "https://sbqr.ru/favicon.ico"
		 url = {"https://sbqr.ru/qr/create/" + formName}
		 />
   

	 
	  <Navbar bg="dark" variant="dark" expand="lg">
		<Navbar.Brand href="/">На главную</Navbar.Brand>
		<Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
			<Nav className="mr-auto">
			  <Nav.Link href="/page/QRcode_dlya_oplaty.html">Создать QR для оплаты</Nav.Link>
			  <Nav.Link href="/#portfolio">Услуги</Nav.Link>
			  <Nav.Link href="/#about">Преимущества</Nav.Link>
			  <Nav.Link href="/wp/">Инструкции</Nav.Link>
			  <Nav.Link href="/#reviews">Отзывы</Nav.Link>
			  <Nav.Link href="/#choice">Контакты</Nav.Link>
			</Nav>	
        </Navbar.Collapse>			
	  </Navbar>
	  
	 
	  <h1>{title}</h1>
	  <div className="intro" dangerouslySetInnerHTML={{__html: intro}}>
	  </div>
  */}	  
 <h2>Для получения QR кода заполните форму</h2>
	  <p>Это бесплатно. Можно скачать в удобном для Вас формате изображения (jpeg, png) или версии для печати в pdf. Можно выбрать красивый дизайн. Добавить свой логотип в QR код.</p>
	  
	<div className="formqr"> 
	<Formik 
		  initialValues={{
			//friends: ['jared', 'ian'],
		  }}
		  onSubmit={values => {
			
			let qrText = "";
			
			if (values)
			{   
		        values["formId"] = this.state.formId; 
				console.log(values);
				this.setState( (state) => {return { isFill: true} } );
				this.setState( (state) => {return { isVisiableQR: false} });
				
				
			// Request in back
			  
			    fetch("https://sbqr.ru/qr/get_qr_text.php", {
				   method: "POST",				   		   
				   body:  JSON.stringify(values)
				})
				.then(res => res.json())
				.then(result => {
					console.log("3. result=" + Object.values(result));
					qrText = Object.values(result)[0];
					this.setState({ rezData: result,
					                valueQR: qrText,
					                isVisiableQR: true});                    					
					});
				if (!this.state.isVisiableQR) {
				   Object.values(this.state.rezData).map( (item,key) => qrText = qrText + item );
                   console.log("qrText=" + qrText);				   
				}
				
				console.log("valueQR=" + this.state.valueQR);				
				
			}
		  }}
		>
		{({ errors, touched, isValidating }) => ( 
				  <Form>
				  {
					  Object.keys(formData).map((ind) =>
					  <div key={ind} className="forminput">
						  
						  <label>{formData[ind].DESCRIPTION}</label>:<br />
						  { ( formData[ind].TYPE_FIELD === "select" ) ? (
											  
								<Field
								  as="select"						
								  name={formData[ind].NAME}
								  id={formData[ind].NAME}
								  required={formData[ind].REQUIRED === "1" ? true : false}
								  validate={(value) => 
									{ 
										let error;
										this.setState( (state) => {return { isVisiableQR: false} });
										if (formData[ind].REG_EXP) {											
											if (!eval(formData[ind].REG_EXP).test(value) ) {
												error = 'Заполните -' + formData[ind].MESSAGE;
												}
										}
										
										return error;
									  } }			
                                  								  
								  >
								  <option value="">Выберите из списка</option>
								  {formData[ind].TOOLTIP.split("|").map( (item) =>  <option key={item} value={item}>{item}</option>  )}        
					
								  </Field>						  
						  )
						 : (				  
								<Field  
									name={formData[ind].NAME}
									id={formData[ind].NAME}
									placeholder={formData[ind].TOOLTIP}
									required={formData[ind].REQUIRED === "1" ? true : false}
                                    validate={(value) => 
									{ 
										let error;
										this.setState( (state) => {return { isVisiableQR: false} });
										if (formData[ind].REG_EXP) {						
											if (!eval(formData[ind].REG_EXP).test(value) ) {
												error = 'Заполните -' + formData[ind].MESSAGE;
												}
										}
										
										return error;
									  } }		
 									
								/>
								
						 	
						 )
						  }
						  {eval(`errors.${formData[ind].NAME}`) && eval(`touched.${formData[ind].NAME}`) && <div className="errorfield">{eval(`errors.${formData[ind].NAME}`)}</div>} 
						  
						  
					 </div>              
					)
					}
				    
					{!this.state.isFill && <div className="errorfield">Заполните необходимые поля и нажмите на кнопку!</div>}
					<div className="buttonStyle">	
					  <button type="submit">Создать QR</button>
					</div>

                  
					
				  </Form>
  )}
		</Formik>
		</div>
		
		
		    <QRdiv      	
			  idQR = {this.state.idQR}
			  formId = {this.state.formId}
			  valueQR = {this.state.valueQR}
			  sizeQR = {this.state.sizeQR}
			  levelQR = {this.state.levelQR}			  
			  typeQR = {this.state.typeQR}
			  posTypeQR = {this.state.posTypeQR}
			  posTypeQR2 = {this.state.posTypeQR2}
			  opacityQR = {this.state.opacityQR}
			  otherColorQR = {this.state.otherColorQR}
			  posColorQR = {this.state.posColorQR}
			  circleColorQR = {this.state.circleColorQR}
			  funcTypeQR = {this.state.funcTypeQR}
			  directionQR = {this.state.directionQR}
			  isMarginQR = {this.state.isMarginQR}
			  scaleQR = {this.state.scaleQR}
			  crossWidthQR = {this.state.crossWidthQR}
			  posWidhQR = {this.state.posWidhQR}
			  lineWidthQR = {this.state.lineWidthQR}
			  isVisiableQR = {this.state.isVisiableQR}	  			  
			  QRstyle = {this.state.QRstyle}
			  icon = {this.state.icon}
			  imgQR = {this.state.imgQR}
			/>
			
      
	  <ChangeStyleQR updateData={this.updateChangeQR} />
	  
	  <div className="row">
		   <div className="col">
			  <div className="left-column"><label htmlFor="levelQR">Качество детализации</label></div>
			  <div className="right-column">
				  <select name="levelQR" value={this.state.levelQR} onChange={this.handleChangeQR.bind(this)}>
					<option value="H">30%</option>            
					<option value="Q">25%</option>				
					<option value="M">15%</option>
					<option value="L">7%</option>				
				  </select>
			  </div>
			</div>
			{  ( visualParametrs[this.state.QRstyle].indexOf("sizeQR") !== -1 ) ? (
			  <div className="col">
				  <div className="left-column"><label htmlFor="sizeQR">Размер</label></div>
				  <div className="right-column"><input type="text" name="sizeQR" value={this.state.sizeQR} onChange={this.handleChangeQR.bind(this)} /> </div>
			  </div>
			) : null  }
	  </div>
	  <div className="row">
	  {  ( visualParametrs[this.state.QRstyle].indexOf("typeQR") !== -1 ) ? (
			<div className="col">
			  <div className="left-column"><label htmlFor="typeQR">Стиль точки</label></div>
			  <div className="right-column">
				  <select name="typeQR" value={this.state.typeQR} onChange={this.handleChangeQR.bind(this)}>
					<option value="rect">Прямоугольник</option>            
					<option value="round">Круг</option>				
					<option value="rand">Случайный</option>				
				  </select>
			  </div>
		   </div>
	  ) : null	  }
	  {  ( visualParametrs[this.state.QRstyle].indexOf("posTypeQR") !== -1 ) ? (
		   <div className="col">
			  <div className="left-column"><label htmlFor="posTypeQR">Якорный стиль</label></div>
			  <div className="right-column">
				  <select name="posTypeQR" value={this.state.posTypeQR} onChange={this.handleChangeQR.bind(this)}>
					<option value="rect">Прямоугольник</option>            
					<option value="round">Круг</option>				
					<option value="planet">Планета</option>				
					<option value="roundRect">Овал</option>				
				  </select>
			  </div>
		  </div>
		  ) : null
	  }
	</div>
	  <div className="row">
	  {  ( visualParametrs[this.state.QRstyle].indexOf("opacityQR") !== -1 ) ? (
		  <div className="col">
			  <div className="left-column"><label htmlFor="opacityQR">Непрозрачность</label></div>
			  <div className="right-column"><input type="text" name="opacityQR" value={this.state.opacityQR} onChange={this.handleChangeQR.bind(this)} /> </div>
		  </div>
		  ) : null
	  }		  
	  {  ( visualParametrs[this.state.QRstyle].indexOf("scaleQR") !== -1 ) ? (
		  <div className="col">
			  <div className="left-column"><label htmlFor="scaleQR">Масштаб</label></div>
			  <div className="right-column"><input type="text" name="scaleQR" value={this.state.scaleQR} onChange={this.handleChangeQR.bind(this)} /> </div>
		  </div>
		) : null  }				  
	  </div>

	  
	  <div className="row" >
	  {  ( visualParametrs[this.state.QRstyle].indexOf("otherColorQR") !== -1 ) ? (
			<div className="col">
			  <div className="left-column"><label>Цвет точки</label></div>  
			  <div className="right-column">
				<SketchColor updateData={this.updateDataOtherColor}  />
			  </div>   
		    </div>
	  ) : null  }				  	
	  {  ( visualParametrs[this.state.QRstyle].indexOf("posColorQR") !== -1 ) ? (
			<div className="col">
			  <div className="left-column"><label>Цвет 3-х привязок</label></div>
			  <div className="right-column">
				<SketchColor updateData={this.updateDataPosColor}  />
			  </div>		   
			</div>	  
      ) : null  }				  				
	  </div>			
	  
	  <div className="row">
	  {  ( visualParametrs[this.state.QRstyle].indexOf("scaleQR") !== -1 ) ? (	  
		   <div className="col">
			  <div className="left-column"><label htmlFor="scaleQR">Толщина вилки</label></div>
			  <div className="right-column"><input type="text" name="crossWidthQR" value={this.state.crossWidthQR} onChange={this.handleChangeQR.bind(this)} /> </div>
		  </div>
	  ) : null  }	
	  {  ( visualParametrs[this.state.QRstyle].indexOf("posWidhQR") !== -1 ) ? (	  	  
		  <div className="col">
			  <div className="left-column"><label htmlFor="posWidhQR">Ширина 3-х привязки</label></div>
			  <div className="right-column"><input type="text" name="posWidhQR" value={this.state.posWidhQR} onChange={this.handleChangeQR.bind(this)} /> </div>
		  </div>
	  ) : null  }			  
      </div>	
	  
  	  <div className="row">
	  {  ( visualParametrs[this.state.QRstyle].indexOf("posTypeQR2") !== -1 ) ? (	  	  
		  <div className="col">
			  <div className="left-column"><label htmlFor="posTypeQR2">Якорный стиль</label></div>
			  <div className="right-column">
				  <select name="posTypeQR2" value={this.state.posTypeQR2} onChange={this.handleChangeQR.bind(this)}>
					<option value="rect">Квадрат</option>            				
					<option value="dsj">Секторы</option>				
				  </select>
			  </div>
		  </div>
	   ) : null  }			  		  
	   {  ( visualParametrs[this.state.QRstyle].indexOf("circleColorQR") !== -1 ) ? (	  	  
		  <div className="col">
			  <div className="left-column"><label htmlFor="circleColorQR">Цвет пузырьков</label></div>
			  <div className="right-column">
				<SketchColor updateData={this.updateDataСircleColor}  />
			  </div>   
		   </div>		  
	   ) : null  }			  		  
	   
	  </div>

	  
  	  <div className="row">
	  {  ( visualParametrs[this.state.QRstyle].indexOf("funcTypeQR") !== -1 ) ? (	  	  
		  <div className="col">
			  <div className="left-column"><label htmlFor="funcTypeQR">Тип</label></div>
			  <div className="right-column">
				  <select name="funcTypeQR" value={this.state.funcTypeQR} onChange={this.handleChangeQR.bind(this)}>
					<option value="A">тип A</option>            				
					<option value="B">тип B</option>				
				  </select>
			  </div>
		  </div>
	   ) : null  }			  		  
	   {  ( visualParametrs[this.state.QRstyle].indexOf("directionQR") !== -1 ) ? (	  	  
		  <div className="col">
			  <div className="left-column"><label htmlFor="directionQR">Направление</label></div>
			  <div className="right-column">
				  <select name="directionQR" value={this.state.directionQR} onChange={this.handleChangeQR.bind(this)}>
					<option value="left-right">Справо на лево</option>            				
					<option value="up-down">Сверху вниз</option>				
					<option value="h-v">Горозонтально вертикально</option>				
					<option value="loop">Петля</option>				
					<option value="topLeft-bottomRight">По диагонали слева</option>				
					<option value="topRight-bottomLeft">По диагонали справа</option>				
					<option value="cross">Пересечение</option>				
				  </select>
			  </div>   
		   </div>		  
	   ) : null  }			  		  
	   
	  </div>
	  

  	  <div className="row">
	  {  ( visualParametrs[this.state.QRstyle].indexOf("lineWidthQR") !== -1 ) ? (	  	  
		  <div className="col">
			  <div className="left-column"><label htmlFor="lineWidthQR">Ширина линий</label></div>
			  <div className="right-column"><input type="text" name="lineWidthQR" value={this.state.lineWidthQR} onChange={this.handleChangeQR.bind(this)} /> </div>
		  </div>
	   ) : null  }
	   
	  </div>

	  
	  
	  {  ( visualParametrs[this.state.QRstyle].indexOf("imgQR") !== -1 ) ? (	  	  			  	  
	  <div className="row" >	

			  <div className="left-column"><label>Изображение/логотип <p>Доступно .jpg, .gif, .png</p><p>Рекомендованное разрешение 100х100 пикселей</p></label>			  </div>	  
			  <div className="right-column">
				  <ImageUploader
						className="right-column"
						withIcon={false}
						withLabel={false}
						buttonText='Загрузить'
						onChange={this.onDrop.bind(this)}
						imgExtension={['.jpg', '.gif', '.png']}
						maxFileSize={5242880}				
						label='Доступно .jpg, .gif, .png '
						fileSizeError='Файл слишком большой. Максимальный размер 5Мб'
						singleImage={true}
						buttonStyles={{width: 100,padding: 0, background: '#fec151'}}
					/>		   
				</div>	
	   
		  
	  </div>			
		) : null  }
	  
	  
{/*	   	  <h2>Описание</h2>
	  <div className="body" dangerouslySetInnerHTML={{__html: body}}>
	  </div>
	  
	  <div className="body" dangerouslySetInnerHTML={{__html: finality}}>
	  </div>
	  */}
	
	  </div>
    );
  }
}

export default App;